<template>
  <div>
    <div class="h1">
      <div class="ww">
        <div class="li-1">
          <div class="qwer">
            <input
              type="text"
              v-model="name"
              placeholder="姓名：与付款姓名一致"
            />
          </div>
        </div>
        <div class="li-2" style="margin-top: .18rem;margin-bottom: .28rem;">
          <span>注：与付款姓名一致，必填</span>
        </div>
        <div class="li-1">
          <div class="qwer">
            <input
              type="text"
              v-model="phone"
              placeholder="手机号：请输入11位手机号"
            />
          </div>
        </div>
        <div class="li-2" style="margin-top: .18rem;margin-bottom: .87rem;">
          <span>11位手机号，必填</span>
        </div>
        <div class="li-3 " @click="receive">
          <img src="../../assets/img/market/market107/btn.png" alt="" />
        </div>
      </div>
    </div>
    <div class="divBG" v-if="tan">
      <div class="content" style="position: relative;">
        <img
          class="btnss"
          style="width: 5.88rem;height: 3.38rem;"
          src="../../assets/img/market/market107/弹窗.png"
          alt=""
        />
        <img
          @click="tanss"
          style="position: absolute;top: 5.02rem;right: -2.4rem;z-index: 999;"
          src="../../assets/img/market/market107/关闭.png"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      phone: "",
      name: "",
      tan: false
    };
  },

  mounted() {},
  methods: {
    tanss() {
      if (this.tan == true) {
        this.tan = false;
      } else {
        this.tan = true;
      }
    },
    receive() {
      var re = /^1[3-9]{1}[0-9]{9}$/;
      if (re.test(this.phone)) {
        this.$router.push({ path: "/market103_success" });
        // this.tan = true;
      } else {
        alert("请输入正确格式的手机号");
        this.phone = "";
      }
    }
  }
};
</script>
<style lang="less" scoped>
* {
  font-size: 16px;
}

.divBG {
  z-index: 999;
  background-color: rgba(31, 30, 30, 0.6);
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 20;

  .content {
    width: 1rem;
    margin: 0 auto;
    position: relative;

    .btnss {
      position: absolute;
      top: 5rem;
      left: -2.45rem;
      z-index: 999;
      width: 6.46rem;
      height: 3.24rem;
    }
  }
}

.h1 {
  width: 100%;
  height: 13.34rem;
  background: url(../../assets/img/market/market108/bg.png);
  background-size: 100% 100%;

  .ww {
    padding-top: 5.8rem;

    input {
      background: none;
      outline: none;
      border: none;
      width: 6rem;
      height: 0.96rem;
    }

    .li-1 {
      margin: 0 auto;
      width: 7.02rem;
      height: 0.96rem;
      background: url(../../assets/img/market/market108/输入框.png);
      background-size: 100% 100%;
      .qwer {
        padding-left: 1rem;

        ::-webkit-input-placeholder {
          /* WebKit browsers */
          color: #3b0606;
          font-weight: 600;
        }

        :-moz-placeholder {
          /* Mozilla Firefox 4 to 18 */
          color: #3b0606;
          font-weight: 600;
        }

        ::-moz-placeholder {
          /* Mozilla Firefox 19+ */
          color: #3b0606;
          font-weight: 600;
        }

        :-ms-input-placeholder {
          /* Internet Explorer 10+ */
          color: #3b0606;
          font-weight: 600;
        }
      }
    }

    .li-2 {
      padding-left: 0.27rem;

      span {
        color: #fff;
        font-size: 0.22rem;
        font-weight: 600;
      }
    }

    .li-3 {
      margin: 0 auto;
      margin-top: 0.07rem;
      width: 7.16rem;
      height: 1.1rem;

      img {
        width: 7.16rem;
        height: 1.1rem;
      }
    }

    .li-4 {
      font-size: 0.24rem;
      color: #d12e58;
      padding-left: 0.4rem;
      margin-top: 0.1rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/market/market108.vue